export default "__VITE_ASSET__67551f9e__"